// extracted by mini-css-extract-plugin
export default {"inner":"BackgroundHome_inner__fpKcJ","image":"BackgroundHome_image__SIw6-"};